























/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { IWorkflowsInputModifyJobsJob } from '@/api/types/request.types'

/* API */

export default Vue.extend({
  name: 'WorkflowJobPicker',

  props: {
    selectedJobId: {
      type: Number,
      default: null,
    },
    jobs: {
      type: Array as () => IWorkflowsInputModifyJobsJob[],
      default: null,
    },
  },

  data() {
    return {
      showDropdown: false,
    }
  },

  computed: {
    internalSelectedJobID: {
      get(): Number {
        return this.selectedJobId
      },
      set(newValue: Number) {
        this.$emit('update:selectedJobId', newValue)
      },
    },
    selectedJobName(): string {
      const job = this.jobs.find(j => j.id === this.internalSelectedJobID)

      if (job) {
        return job.name
      }

      return 'No Job Selected!'
    },
  },

  methods: {
    handleSelect(jobID: number) {
      this.internalSelectedJobID = jobID
      this.showDropdown = true
      this.$nextTick(() => {
        this.showDropdown = false
      })
    },
  },
})
